import { ca } from '@cian/analytics';

export function trackQuickLinksView() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'view_alsoLooking',
    label: '',
  });
}

export function trackQuickLinkClick(url: string, title: string) {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_alsoLooking',
    label: url,
  });

  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_fast_link',
    label: title,
    page: {
      extra: {
        query_string: url.split('?')[1] || '',
      },
    },
    useLastProducts: true,
  });
}
